module.exports = __webpack_public_path__ + "img/Apoptosis-CRC_GSE225857.da52fdbc.png";